import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

interface UploadDialogProps {
  open: boolean;
  onClose: (e: any) => void;
  fileUploadBody: React.ReactNode;
  fileUploadActions: React.ReactNode;
  isComplete: boolean;
}

export const UploadDialog: React.FC<UploadDialogProps> = ({ open, onClose, fileUploadBody, fileUploadActions, isComplete }) => {
  const handleUploadCancel = (e: any) => {
    e.preventDefault();
    onClose(e);
  };

  return (
    <Dialog open={open} onClose={handleUploadCancel} sx={{
      "& .MuiDialog-paper": {
        borderRadius: "20px",
        minHeight: "350px",
        m: { xs: 0, sm: '32px' },
        width: { xs: '100%', sm: 'calc(100% - 64px)' },
      },
    }}
    fullWidth={true}>
      <DialogTitle sx={{ textAlign: "center", fontWeight: "300", fontSize: "32px" }}>
        Upload Files
      </DialogTitle>
      <DialogContent>
        {fileUploadBody}
      </DialogContent>
      <DialogActions>
        {fileUploadActions}
        <Button variant={isComplete ? 'rounded' : 'contained'} sx={{ ml: 0 }}  onClick={handleUploadCancel}>
          {isComplete ? "I'm done" : "Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};